<template>
  <div id="zbDialog">
    <div class="item">
      <label for="">节点类型</label>
      <div>指标</div>
    </div>
    <div class="item">
      <label for="">节点属性</label>
      <div>指标拆解</div>
    </div>
    <div class="item">
      <label for="">时间</label>
      <div>
        <el-date-picker
          v-model="value1"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="item">
      <label for="">目标</label>
      <div>
        <el-input size="mini"></el-input>
      </div>
    </div>
    <div class="item">
      <label for="">关联上级部门任务</label>
      <div>
        <el-select v-model="value" size="mini" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="item">
      <label for="">单位</label>
      <div>亿</div>
    </div>
    <div class="item">
      <label for="">指标趋势属性</label>
      <div>向上</div>
    </div>
    <div class="item">
      <label for="">指标当前值</label>
      <div>1.2亿</div>
    </div>
    <div class="item">
      <label for="">看板地址</label>
      <div class="item-kanban">
        <el-input size="mini"></el-input>
        <el-link class="link">去配置</el-link>
      </div>
    </div>
    <div class="item-table">
      <label for="">产品维度拆解表</label>
      <div>
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="产品服务"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="值"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: [

  ],
  data () {
    return {
      tableData: [{
        date: '亲子服务',
        name: '1'
      }, {
        date: '老人服务',
        name: '4'
      }, {
        date: '小孩服务',
        name: '3'
      }, {
        date: '情侣套餐',
        name: '5'
      }]
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  },
  components: {

  }
}
</script>

  <style scoped lang="stylus">
  #zbDialog
    padding 0 10px
    .item
      display flex
      color: #999
      font-size: 16px
      margin-bottom: 10px
      align-items: center
      label
        margin-right 10px
        color: #000
    .item-kanban
      display flex
      .link
        white-space nowrap
        margin-left: 10px
    .item-table
      label
        font-size: 16px
      >>> td
            padding: 5px
  </style>
